import React, { createContext, useContext, useState, useEffect } from 'react'

const LanguageContext = createContext({ lang:'en', language:'en', t:(k)=>k, showBanner:false, dismissBanner:()=>{}, setLang:()=>{} })

export const TRANSLATIONS = {
  en: {
    // NAV
    nav_signin: 'Sign In',
    nav_home: 'Home',
    nav_get_started: 'Get Started',
    nav_services: 'Services',
    nav_about: 'About Us',
    nav_contact: 'Contact',

    // HERO — clean 3-line copy + 3 CTAs (Nancy, May 16, 2026)
    hero_h1_line1: 'Professional Notary Signing Services',
    hero_h1_line2: 'Highly Regarded Nationwide',
    hero_h1_line3: 'By Mortgage Companies, Law Firms,\u00A0and\u00A0Consumers',
    hero_h1_gold: 'By Mortgage Companies, Law Firms, and Consumers',
    hero_desc: 'Connecting YOU with certified Mobile & Remote Online Notaries in all 50 states.',
    hero_cta: 'Choose How to Get Started',
    hero_cta_individuals: 'Request a Notary',
    hero_cta_individuals_sub: 'For Individuals',
    hero_cta_companies: 'Order a Signing',
    hero_cta_companies_sub: 'For Companies',
    hero_cta_notaries: 'Join Our Network',
    hero_cta_notaries_sub: 'For Notaries',

    // TRUST STRIP
    trust_1: 'Background-Checked',
    trust_2: 'E&O Insured',
    trust_3: 'RON & Mobile Notaries',
    trust_4: 'Notary Signing Certified Agents',
    trust_5: 'All 50 States Covered',

    // PORTALS
    portal_heading: 'How Can We Help You?',
    portal_sub_1: 'Choose the portal that fits your role —',
    portal_sub_2: 'everything you need is inside.',
    portal_co_eyebrow: 'COMPANIES',
    portal_co_title: 'Title, Escrow & Legal Firms',
    portal_co_desc: 'Order Signings, Track Assignments, and Manage Invoices from One Professional Dashboard.',
    portal_co_cta: 'Get Started',
    portal_ind_eyebrow: 'INDIVIDUALS',
    portal_ind_title: 'Personal Notary Services',
    portal_ind_desc: 'Need a Notary at your Home, Office, Hospital, Favorite Coffee Shop or Restaurant? We come to you — anywhere, anytime.',
    portal_ind_cta: 'Request a Notary',
    portal_not_eyebrow: 'NOTARIES',
    portal_not_title: 'Notary Signing Agents',
    portal_not_desc: 'Are you a certified notary signing agent? Join our nationwide network, grow your presence, and receive signing assignments in your area.',
    portal_not_cta: 'Apply Now',
    portal_signin_hint: 'Already have an account?',
    portal_signin_link: 'Sign in here',

    // FOOTER
    footer_copy: '© 2019–2026 Notary Signing Vault, LLC — All rights reserved',
    footer_veteran: 'Veteran & Hispanic Owned and Operated',
    footer_services: 'Services',
    footer_about: 'About Us',
    footer_contact: 'Contact',
    footer_accessibility: 'Accessibility',
    footer_signin: 'Sign In',
    footer_register: 'Register',

    // LANGUAGE TOGGLE
    lang_toggle: '🇪🇸 Español',
    lang_toggle_short: '🇪🇸',

    // LANGUAGE BANNER
    lang_banner: '¿Prefieres español?',
    lang_banner_btn: 'Ver en Español',
    lang_banner_dismiss: 'No thanks',

    // LOGIN PAGE
    login_welcome: 'Welcome back',
    login_sub: 'Sign in to access your portal',
    login_email: 'Email address',
    login_password: 'Password',
    login_btn: 'Sign in',
    login_loading: 'Signing in...',
    login_no_account: "Don't have an account?",
    login_register: 'Register here',
    login_notary: 'Join as notary',
    login_client: 'Register as title company',
    login_individual: 'Individual order',

    // REGISTER PAGE
    register_title: 'Create your account',
    register_sub: "Select how you'll use LCA",
    register_continue: 'Continue →',
    register_back: '← Back',
    register_registering: 'Registering as',
    register_already: 'Already have an account?',
    register_signin: 'Sign in',
    register_create: 'Create account',
    register_creating: 'Creating account...',

    // OLD HERO (kept for other pages)
    hero_trusted: 'TRUSTED NATIONWIDE',
    hero_title_1: 'Professional Signing Coordination',
    hero_title_2: 'Trusted',
    hero_title_3: 'Nationwide',
    hero_sub: 'Title companies · Escrow firms · Attorneys · Lenders\nNursing homes · Car dealerships · Individuals',
    how_title: 'How it works',
    how_sub: 'Simple, fast, and professional — no matter who you are',
    how_individuals: 'FOR INDIVIDUALS REQUESTING A NOTARY SERVICE',
    how_companies: 'FOR COMPANIES REQUESTING A SIGNING',
    how_notaries: 'FOR NOTARY SIGNING AGENTS JOINING OUR NETWORK',
    ind_1_t: 'Tell us what you need', ind_1_d: 'Fill out a short form — tell us what you need signed, where you are, and when works best.',
    ind_2_t: 'We find your notary', ind_2_d: 'We match you with a professional notary near you — usually within a few hours!',
    ind_3_t: 'Pay securely online', ind_3_d: 'Quick and easy online payment when you submit. No surprises, no hidden fees.',
    ind_4_t: 'Notary comes to you', ind_4_d: 'Your notary arrives at your home, office, or wherever is most convenient for you.',
    com_1_t: 'Submit your order', com_1_d: 'Submit signing details — borrower info, location, date, document type, and special instructions.',
    com_2_t: 'We match a notary', com_2_d: 'We assign a certified, background-checked, E&O insured signing agent — typically within hours.',
    com_3_t: 'Signing completed', com_3_d: 'Your notary arrives professionally prepared. Documents signed, notarized, and confirmed.',
    com_4_t: 'Invoice & confirmation', com_4_d: 'Receive instant confirmation and a detailed invoice. Everything tracked in your portal.',
    not_1_t: 'Apply & onboard', not_1_d: 'Complete your profile, upload your commission, E&O insurance, W-9, government ID, and background check.',
    not_2_t: 'Get approved', not_2_d: "Our compliance team reviews your credentials within 1 business day. You'll be notified by email.",
    not_3_t: 'Accept signings', not_3_d: 'Receive job assignments matching your location and expertise. Accept with one click.',
    not_4_t: 'Complete & get paid', not_4_d: 'Complete the signing, confirm in your portal, and receive payment by direct deposit or check.',
    serve_title: 'Who we serve',
    serve_sub: 'We coordinate signings for a wide range of clients across all industries',
    serve_1_title: 'Title Companies', serve_1_desc: 'Residential and commercial closings handled with precision and speed.',
    serve_2_title: 'Real Estate Attorneys', serve_2_desc: 'Attorney-state closings coordinated by licensed notaries in your jurisdiction.',
    serve_3_title: 'Mortgage Lenders & Banks', serve_3_desc: 'Refinance, purchase, and HELOC packages executed by certified signing agents.',
    serve_4_title: 'Escrow Companies', serve_4_desc: 'Seamless coordination between escrow, title, and notary for smooth closings.',
    serve_5_title: 'Nursing Homes & Care Facilities', serve_5_desc: 'Mobile notary services for residents who need documents signed on-site.',
    serve_6_title: 'Car Dealerships', serve_6_desc: 'Finance documents, title transfers, lease agreements, and vehicle purchase contracts.',
    serve_7_title: 'Individuals & Borrowers', serve_7_desc: 'Personal loan closings, POA, affidavits, and more — at your home or office.',
    portal_title: 'A portal for everyone',
    portal_sub: "One login — tell us who you are and we'll take you to the right place",
    portal_companies_title: 'Companies & Organizations',
    portal_companies_desc: 'For title companies, escrow firms, real estate attorneys, mortgage lenders, banks, nursing homes, car dealerships, and any organization that needs signing services.',
    portal_companies_features: '✓ Submit & track orders · ✓ Real-time status · ✓ Invoice management · ✓ Volume pricing',
    portal_companies_cta: 'Register as a company →',
    portal_ind_title: 'Individuals & Borrowers',
    portal_ind_desc: "Need a notary for your personal loan closing, refinance, power of attorney, affidavit, or any personal document? We'll send one to you.",
    portal_ind_features: '✓ Mobile signing at your location · ✓ Same-day availability · ✓ Track your notary · ✓ Easy payment',
    portal_ind_cta: 'Request a signing →',
    portal_not_title: 'Notary Signing Agents',
    portal_not_desc: 'Are you a certified notary signing agent? Join our nationwide network, grow your presence, and receive signing assignments in your area.',
    portal_not_features: '✓ Consistent jobs · ✓ Fast payment · ✓ Build your rank · ✓ Manage credentials',
    portal_not_cta: 'Apply as notary →',
    portal_signin: 'Already have an account?',
    portal_signin_link: 'Sign in here →',
  },

  es: {
    // NAV
    nav_signin: 'Iniciar Sesión',
    nav_home: 'Inicio',
    nav_get_started: 'Comenzar',
    nav_services: 'Servicios',
    nav_about: 'Nosotros',
    nav_contact: 'Contacto',

    // HERO — clean 3-line copy + 3 CTAs (Nancy, May 16, 2026)
    hero_h1_line1: 'Servicios Profesionales de Notarización',
    hero_h1_line2: 'Altamente Reconocidos a Nivel Nacional',
    hero_h1_line3: 'Por Compañías Hipotecarias, Despachos Legales\u00A0y\u00A0Consumidores',
    hero_h1_gold: 'Por Compañías Hipotecarias, Despachos Legales y Consumidores',
    hero_desc: 'Conectándote con Notarios Móviles y Remotos Certificados en los 50 estados.',
    hero_cta: 'Elija Cómo Comenzar',
    hero_cta_individuals: 'Solicitar un Notario',
    hero_cta_individuals_sub: 'Para Particulares',
    hero_cta_companies: 'Ordenar una Firma',
    hero_cta_companies_sub: 'Para Compañías',
    hero_cta_notaries: 'Únete a Nuestra Red',
    hero_cta_notaries_sub: 'Para Notarios',

    // TRUST STRIP
    trust_1: 'Verificación de Antecedentes',
    trust_2: 'Seguro E&O',
    trust_3: 'Notarios RON y Móviles',
    trust_4: 'Agentes Notariales Certificados',
    trust_5: 'Los 50 Estados Cubiertos',

    // PORTALS
    portal_heading: '¿Cómo Podemos Ayudarte?',
    portal_sub_1: 'Elige el portal que se adapte a tu rol —',
    portal_sub_2: 'todo lo que necesitas está adentro.',
    portal_co_eyebrow: 'EMPRESAS',
    portal_co_title: 'Título y Custodia',
    portal_co_desc: 'Ordena Firmas, Rastrea Asignaciones y Administra Facturas desde un Panel Profesional.',
    portal_co_cta: 'Comenzar',
    portal_ind_eyebrow: 'INDIVIDUOS',
    portal_ind_title: 'Servicios Notariales Personales',
    portal_ind_desc: '¿Necesitas un Notario en tu Casa, Oficina, Hospital, Cafetería o Restaurante favorito? Vamos a ti — en cualquier lugar, en cualquier momento.',
    portal_ind_cta: 'Solicitar un Notario',
    portal_not_eyebrow: 'NOTARIOS',
    portal_not_title: 'Agentes Notariales de Firma',
    portal_not_desc: '¿Eres notario certificado para firmas de documentos y cierres? Únete a nuestra red nacional, aumenta tu presencia y recibe asignaciones de firmas cerca de ti.',
    portal_not_cta: 'Aplicar Ahora',
    portal_signin_hint: '¿Ya tienes una cuenta?',
    portal_signin_link: 'Inicia sesión aquí',

    // FOOTER
    footer_copy: '© 2019–2026 Notary Signing Vault, LLC — Todos los derechos reservados',
    footer_veteran: 'Propiedad y Operación de Veteranos e Hispanos',
    footer_services: 'Servicios',
    footer_about: 'Nosotros',
    footer_contact: 'Contacto',
    footer_accessibility: 'Accesibilidad',
    footer_signin: 'Iniciar Sesión',
    footer_register: 'Registrarse',

    // LANGUAGE TOGGLE — shows what you can switch TO
    lang_toggle: '🇺🇸 English',
    lang_toggle_short: '🇺🇸',

    // LANGUAGE BANNER
    lang_banner: 'We also speak English!',
    lang_banner_btn: 'Switch to English',
    lang_banner_dismiss: 'No gracias',

    // LOGIN PAGE
    login_welcome: 'Bienvenido de vuelta',
    login_sub: 'Inicia sesión para acceder a tu portal',
    login_email: 'Correo electrónico',
    login_password: 'Contraseña',
    login_btn: 'Iniciar sesión',
    login_loading: 'Iniciando sesión...',
    login_no_account: '¿No tienes una cuenta?',
    login_register: 'Regístrate aquí',
    login_notary: 'Únete como notario',
    login_client: 'Registrarse como compañía de título',
    login_individual: 'Orden individual',

    // REGISTER PAGE
    register_title: 'Crea tu cuenta',
    register_sub: '¿Cómo usarás LCA?',
    register_continue: 'Continuar →',
    register_back: '← Atrás',
    register_registering: 'Registrándose como',
    register_already: '¿Ya tienes una cuenta?',
    register_signin: 'Inicia sesión',
    register_create: 'Crear cuenta',
    register_creating: 'Creando cuenta...',

    // OLD HERO (kept for other pages)
    hero_trusted: 'DE CONFIANZA NACIONAL',
    hero_title_1: 'Coordinación Profesional de Firmas',
    hero_title_2: 'De Confianza',
    hero_title_3: 'en Todo el País',
    hero_sub: 'Compañías de título · Firmas de custodia · Abogados · Prestamistas\nHogares de ancianos · Concesionarios · Individuos',
    how_title: 'Cómo funciona',
    how_sub: 'Simple, rápido y profesional — sin importar quién seas',
    how_individuals: 'PARA INDIVIDUOS QUE SOLICITAN UN SERVICIO NOTARIAL',
    how_companies: 'PARA EMPRESAS QUE SOLICITAN UNA FIRMA',
    how_notaries: 'PARA AGENTES NOTARIALES QUE SE UNEN A NUESTRA RED',
    ind_1_t: 'Dinos qué necesitas', ind_1_d: 'Completa un formulario corto — dinos qué necesitas firmar, dónde estás y cuándo te viene bien.',
    ind_2_t: 'Encontramos tu notario', ind_2_d: '¡Te conectamos con un notario profesional cerca de ti — generalmente en pocas horas!',
    ind_3_t: 'Paga de forma segura', ind_3_d: 'Pago rápido y fácil en línea al enviar tu solicitud. Sin sorpresas ni cargos ocultos.',
    ind_4_t: 'El notario viene a ti', ind_4_d: 'Tu notario llega a tu casa, oficina o donde sea más conveniente para ti.',
    com_1_t: 'Envía tu orden', com_1_d: 'Envía los detalles de la firma — info del prestatario, ubicación, fecha, tipo de documento e instrucciones especiales.',
    com_2_t: 'Asignamos un notario', com_2_d: 'Asignamos un agente certificado, con antecedentes verificados y seguro E&O — típicamente en horas.',
    com_3_t: 'Firma completada', com_3_d: 'Tu notario llega preparado profesionalmente. Documentos firmados, notariados y confirmados.',
    com_4_t: 'Factura y confirmación', com_4_d: 'Recibe confirmación instantánea y una factura detallada. Todo rastreado en tu portal.',
    not_1_t: 'Aplica y regístrate', not_1_d: 'Completa tu perfil, sube tu comisión, seguro E&O, W-9, ID gubernamental y verificación de antecedentes.',
    not_2_t: 'Obtén aprobación', not_2_d: 'Nuestro equipo de cumplimiento revisa tus credenciales en 1 día hábil. Te notificaremos por correo.',
    not_3_t: 'Acepta trabajos', not_3_d: 'Recibe asignaciones que coincidan con tu ubicación y experiencia. Acepta con un clic.',
    not_4_t: 'Completa y cobra', not_4_d: 'Completa la firma, confirma en tu portal y recibe pago por depósito directo o cheque.',
    serve_title: 'A quiénes servimos',
    serve_sub: 'Coordinamos firmas para una amplia gama de clientes en todas las industrias',
    serve_1_title: 'Compañías de Título', serve_1_desc: 'Cierres residenciales y comerciales manejados con precisión y rapidez.',
    serve_2_title: 'Abogados de Bienes Raíces', serve_2_desc: 'Cierres en estados de abogados coordinados por notarios con licencia en su jurisdicción.',
    serve_3_title: 'Prestamistas Hipotecarios y Bancos', serve_3_desc: 'Paquetes de refinanciamiento, compra y HELOC ejecutados por agentes certificados.',
    serve_4_title: 'Compañías de Custodia', serve_4_desc: 'Coordinación perfecta entre custodia, título y notario para cierres sin problemas.',
    serve_5_title: 'Hogares de Ancianos y Centros de Cuidado', serve_5_desc: 'Servicios notariales móviles para residentes que necesitan documentos firmados en el lugar.',
    serve_6_title: 'Concesionarios de Autos', serve_6_desc: 'Documentos de financiamiento, transferencias de título, contratos de arrendamiento y compra de vehículos.',
    serve_7_title: 'Individuos y Prestatarios', serve_7_desc: 'Cierres de préstamos personales, POA, declaraciones juradas y más — en tu casa u oficina.',
    portal_title: 'Un portal para todos',
    portal_sub: 'Un inicio de sesión — dinos quién eres y te llevamos al lugar correcto',
    portal_companies_title: 'Empresas y Organizaciones',
    portal_companies_desc: 'Para compañías de título, firmas de custodia, abogados de bienes raíces, prestamistas, bancos, hogares de ancianos, concesionarios y cualquier organización que necesite servicios de firma.',
    portal_companies_features: '✓ Envía y rastrea órdenes · ✓ Estado en tiempo real · ✓ Gestión de facturas · ✓ Precios por volumen',
    portal_companies_cta: 'Registrarse como empresa →',
    portal_ind_title: 'Individuos y Prestatarios',
    portal_ind_desc: '¿Necesitas un notario para tu cierre de préstamo personal, refinanciamiento, poder notarial, declaración jurada o cualquier documento personal? Te enviamos uno.',
    portal_ind_features: '✓ Firma móvil en tu ubicación · ✓ Disponibilidad el mismo día · ✓ Rastrea tu notario · ✓ Pago fácil',
    portal_ind_cta: 'Solicitar una firma →',
    portal_not_title: 'Agentes Notariales de Firma',
    portal_not_desc: '¿Eres notario certificado para firmas de documentos y cierres? Únete a nuestra red nacional, aumenta tu presencia y recibe asignaciones de firmas cerca de ti.',
    portal_not_features: '✓ Trabajos consistentes · ✓ Pago rápido · ✓ Construye tu rango · ✓ Administra credenciales',
    portal_not_cta: 'Aplicar como notario →',
    portal_signin: '¿Ya tienes una cuenta?',
    portal_signin_link: 'Inicia sesión aquí →',
  }
}

export function LanguageProvider({ children }) {
  // ── Read from localStorage immediately so language persists across ALL pages ──
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem('lca_lang')
      if (saved === 'en' || saved === 'es') return saved
      const browserLang = navigator.language || navigator.userLanguage || 'en'
      if (browserLang.toLowerCase().startsWith('es')) {
        localStorage.setItem('lca_lang', 'es')
        return 'es'
      }
    } catch (e) {}
    return 'en'
  })
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    // Sync if localStorage was updated externally
    const saved = localStorage.getItem('lca_lang')
    if (saved === 'en' || saved === 'es') setLangState(saved)
  }, [])

  // ── THIS is the key fix — always saves AND updates state ──
  function switchLang(newLang) {
    if (newLang !== 'en' && newLang !== 'es') return
    localStorage.setItem('lca_lang', newLang)
    setLangState(newLang)
    setShowBanner(false)
  }

  function dismissBanner() {
    setShowBanner(false)
    localStorage.setItem('lca_lang_dismissed', 'true')
  }

  const t = (key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS['en'][key] || key

  return (
    <LanguageContext.Provider value={{ lang, language: lang, setLang: switchLang, t, showBanner, dismissBanner }}>
      {showBanner && (
        <div style={{
          background: '#C9A84C', color: '#0D1B3E', padding: '10px 20px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          gap: 12, fontSize: 13, fontWeight: 500,
          position: 'sticky', top: 0, zIndex: 200, flexWrap: 'wrap',
        }}>
          <span>{t('lang_banner')}</span>
          <button
            onClick={() => switchLang(lang === 'en' ? 'es' : 'en')}
            style={{ background: '#0D1B3E', color: '#C9A84C', border: 'none', padding: '4px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: 500 }}>
            {t('lang_banner_btn')}
          </button>
          <button
            onClick={dismissBanner}
            style={{ background: 'transparent', color: '#0D1B3E', border: '1px solid rgba(13,27,62,0.3)', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
            {t('lang_banner_dismiss')}
          </button>
        </div>
      )}
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
